<template>
    <div class="profile">
        <div class="profile__img">
            <div class="profile__bg"></div>
            <template v-if="imgList.length > 0">
                <swiper :spaceBetween="30" :autoplay="{
                                    delay: 3500,
                                    disableOnInteraction: false,
                                    }" :effect="'fade'" :navigation="true" :speed="2000" :modules="modules" class="profileSwiper">
                    <swiper-slide v-for="(i, index) in imgList" :key="i.attachNo">
                        <img :src="`/displayFile.do?attachNo=${i.attachNo}`" :class="`fade-image${index}`" alt="이미지">
                        <!-- <img src="/resource/img/test02.png" alt="이미지"> -->
                    </swiper-slide>
                </swiper>
            </template>
            <div class="none-img" v-else>
                <img src="@/assets/resource/img/doctor_none_img.png" alt="이미지" >
            </div>
            <!-- <div class="profile__img-wrap">
                <template v-if="imgList.length > 0">
                    <img :src="`/displayFile.do?attachNo=${i.attachNo}`" alt="이미지" v-for="i in imgList">
                </template>
            </div> -->
            <!-- 모바일에 노출 -->
            <div class="profile__img-tit">
                <div class="profile__inner arabic">
                    <span class="department-name">{{docDeptNm}}</span>
                    <span class="name">{{info.drNameGlb}} دكتور جامعى</span>
                </div>
            </div>
        </div>
        <div class="profile__info">
            <div class="profile__inner arabic">
                <div class="profile__info-tit">
                    <span class="department-name">{{docDeptNm}}</span>
                    <span class="name">{{info.drNameGlb}} دكتور جامعى</span>
                </div>
            </div>
            <div class="contents profile__cont">
                <div class="profile__top">
                    <div id="diagnosis" class="box pb0">
                        <div class="profile__specialty arabic">
                            <div class="text">
                                <div class="tit">مجال الطب التخصصي</div>
                                <div class="desc">{{info.detailField}}</div>
                            </div>
                        </div>
                    </div>
                    <div class="contents">
                        <div class="box">
                            <div class="profile__specialty arabic">
                                <div class="text">
                                    <div class="profile__tit-box">
                                        <div class="tit">ساعات العمل</div>
                                        <ul class="profile__tit-list">
                                            <li class="profile__tit-item">مغلقة</li>
                                            <li class="profile__tit-item">متاح للحجز</li>
                                            <li class="profile__tit-item">صباح</li>
                                            <li class="profile__tit-item">بعد الظهر</li>
                                        </ul>
                                    </div>
                                    <!-- <div class="profile__tit-select">
                                    <select>
                                        <option value="대동맥센터">대동맥센터</option>
                                    </select>
                                </div> -->
                                </div>
                            </div>
                        </div>
                        <ar_Calendar :classList="classList" @getClass="getDoctorSchedule" />

                        <!-- <div class="botton-wrap">
                            <a href="javascript:;" class="main-button c-main" @click="normalReservation(info)"><img src="@/assets/resource/icon/calender-check.svg" alt="">진료예약</a>
                            <a href="javascript:;" class="main-button c-sub" @click="showPopup"><img src="@/assets/resource/icon/calender-phone.svg" alt="">간편예약</a>
                            <router-link to="/kr/thanks/register" class="main-button c-gray"><img src="@/assets/resource/icon/calender-love.svg" alt="">고맙습니다</router-link>
                        </div> -->
                    </div>
                </div>
                <div class="box arabic" id="book" v-if="record.R">
                    <div class="profile__tit">ورقة</div>
                    <div class="profile__book">
                        <template v-for="(R, idx) in record.R">
                            <p class="desc" v-if="idx < record.cnt.R">{{R.title}}</p>
                        </template>
                    </div>
                    <button href="javascript:;" class="weekly__calendar-btn type2" v-if="expandedCheck('R')" @click="more('R')">المزيد +</button>
                </div>
            </div>
        </div>
    </div>
    <kr_SimpleRsvPopup :popupVisible="popupVisible" :info="info" @hide-popup="hidePopup" />
</template>



<script>
    import Calendar from '@/components/kr/common/Calendar.vue';
    import { gsap, ScrollTrigger } from "gsap/all";

    // Import Swiper Vue.js components
    import { Swiper, SwiperSlide } from 'swiper/vue';

    // Import Swiper styles
    import 'swiper/css';

    import 'swiper/css/effect-fade';
    import 'swiper/css/navigation';
    import 'swiper/css/pagination';

    import { EffectFade, Navigation, Pagination, Autoplay } from 'swiper/modules';
    export default {
        components: {
            Calendar,
            Swiper,
            SwiperSlide,
        },
        data() {
            return {
                activeSection: 'diagnosis',
                drSid: this.$route.query.drSid || '',
                deptCd: this.$route.query.deptCd || '',
                info: '',
                schedule: '',
                record: {},
                // 의료진 스케쥴 리스트
                classList: '',
                popupVisible: false,
                imgList: [],
                sysYear: new Date().getFullYear(),
                observer: null,
                docDeptNm: '',
            };
        },
        setup() {
            return {
                modules: [EffectFade, Navigation, Pagination, Autoplay],
            };
        },
        methods: {
            goArticle(article) {
                if (article.linkUrl != '' && article.linkUrl != null) {
                    if (article.linkMethod == '_blank') {
                        window.open(article.linkUrl);
                    } else {
                        location.href = article.linkUrl;
                    }
                } else {
                    this.$router.push({
                        path: `/${this.$store.getters.getLang}/${article.boardId}/view`,
                        query: { boardNo: article.boardNo, articleNo: article.articleNo }
                    });
                }
            },
            favoInfo(info) {
                if (!info) return false
                const obj = {}
                obj.favoYn = info.favoYn == 'Y' ? 'Y' : 'N'
                obj.no = info.drSid
                obj.type = 'DOCTOR'
                obj.doctorDetail = true
                return obj
            },
            scrollTo(id) {
                const element = document.getElementById(id);
                if (element) {
                    element.scrollIntoView({ behavior: 'smooth' });
                }
            },
            handleIntersection(entries) {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        this.activeSection = entry.target.id;
                        console.log(entry.target.id);
                    }
                });
            },
            // 의사 정보
            getDoctorInfo() {
                const params = {
                    drSid: this.drSid,
                    hospId: this.$store.getters.getHost,
                    langCd: this.$store.getters.getLang
                }
                this.axios.get(`/api/doctorApi/${this.drSid}`, { params: params })
                    .then(res => {
                        const data = res.data
                        this.info = data
                        if (data.attachBag.profile) {
                            this.imgList = data.attachBag.profile
                        }
                        this.docDeptNm = data.deptNm ? data.deptNm : data.mainDeptNm
                        for(let i of data.doctorDeptList){
                            if(i.deptType == 1){
                                const deptNm = i.deptNmGlb ? i.deptNmGlb : i.deptNm
                                this.docDeptNm += this.docDeptNm ? `, ${deptNm}` : deptNm
                            }
                        }
                    }).catch(err => {
                        console.error(err)
                    })
            },
            getDoctorSchedule(selDt) {
                if (!selDt) {
                    const today = new Date();
                    const year = today.getFullYear();
                    const month = ('0' + (today.getMonth() + 1)).slice(-2);

                    selDt = year + month;
                }
                const param = {
                    hospId: this.$store.getters.getHost,
                    deptCd: this.deptCd,
                    drSid: this.drSid,
                    IN_MED_YM: selDt
                }
                this.axios.get(this.api.doctor.schedule, { params: param })
                    .then(res => {
                        const data = res.data
                        this.schedule = data.schedule
                        if (this.schedule && this.schedule.length > 0) {
                            this.classList = this.schedule.map(i => ({
                                text: i.MED_DT.replaceAll('-', ''),
                                dayType: i.MED_RSV_YN === 'Y' ? 'full' : '',
                                MED_TP: i.MED_TP,
                                NSP_RSN_TP_CD: i.NSP_RSN_TP_CD
                            }))
                        }
                    })
            },
            // 기본정보구분(E:학력/C:경력및연수/A:수상경력/S:학회활동/B:저서/R:논문)
            getDoctorDetail() {
                const param = {
                    drSid: this.drSid,
                    orderBy: 'desc'
                }
                this.axios.get(this.api.doctor.record, { params: param })
                    .then(res => {
                        this.record = res.data.reduce((acc, curr) => {
                            acc[curr.gubun] = acc[curr.gubun] || []
                            acc[curr.gubun].push(curr)
                            acc['cnt'] = acc['cnt'] || {}
                            acc['cnt'][curr.gubun] = 5
                            acc['expanded'] = acc['expanded'] || {}
                            acc['expanded'][curr.gubun] = acc['expanded'][curr.gubun] || false
                            return acc
                        }, {})

                        const newsParam = {
                            drSid: this.drSid
                        }
                        this.axios.get(this.api.article.newsList, { params: newsParam })
                            .then(resp => {
                                const newsCnt = resp.data.totCnt
                                if (newsCnt > 0) {
                                    this.record.news = resp.data.list
                                    this.record.cnt.news = 10
                                    this.record.expanded.news = false
                                }

                                const thanksParam = {
                                    refDrSid: this.drSid,
                                    item18: 'O',
                                    hospId: this.$store.state.hospStore.host
                                }

                                this.axios.get(this.api.article.list + '10', { params: thanksParam })
                                    .then(response => {
                                        const thanksCnt = response.data.totCnt
                                        if (thanksCnt > 0) {
                                            this.record.thanks = response.data.list
                                            this.record.cnt.thanks = 10
                                            this.record.expanded.thanks = false
                                        }

                                        this.observeSections()
                                    })
                            })
                    })
            },
            expandedCheck(gubun) {
                return this.record[gubun] && this.record[gubun].length > 5 && !this.record['expanded'][gubun]
            },
            more(gubun) {
                this.record.cnt[gubun] = this.record[gubun].length
                this.record.expanded[gubun] = true
            },
            normalReservation(doctor) {
                this.$store.state.reserveStore.normalReserve = doctor
                this.$store.state.patInfoStore = {}
                this.$router.push('/kr/reserve/reservation')
            },
            showPopup() {
                this.popupVisible = true
            },
            hidePopup() {
                this.popupVisible = false
            },
            observeSections() {
                const sections = document.querySelectorAll('#diagnosis, #education, #book, #news, #thank');

                sections.forEach(section => {
                    if (section) {
                        this.observer.observe(section);
                    }
                });
            }
        },
        mounted() {
            if (!this.deptCd || !this.drSid) {
                alert("잘못된 접근입니다.")
                this.$router.push('/')
                return
            }

            this.getDoctorInfo()
            this.getDoctorSchedule()
            this.getDoctorDetail()

            const options = {
                root: null,
                rootMargin: '0px',
                threshold: 0.5, // 섹션의 절반 이상이 보일 때 active 설정
            };

            this.observer = new IntersectionObserver(this.handleIntersection, options);
        },
    };
</script>